import { ActivityPlanningDateSelectionWeekConfigInterface } from './interfaces/week.config.interface';

export const weekConfig: ActivityPlanningDateSelectionWeekConfigInterface[] = [
  {
    labelKey: 'activity_planning.date_selection.week.monday',
    formControlName: 'monday',
    fullCalendarDayIndex: 1,
  },
  {
    labelKey: 'activity_planning.date_selection.week.tuesday',
    formControlName: 'tuesday',
    fullCalendarDayIndex: 2,
  },
  {
    labelKey: 'activity_planning.date_selection.week.wednesday',
    formControlName: 'wednesday',
    fullCalendarDayIndex: 3,
  },
  {
    labelKey: 'activity_planning.date_selection.week.thursday',
    formControlName: 'thursday',
    fullCalendarDayIndex: 4,
  },
  {
    labelKey: 'activity_planning.date_selection.week.friday',
    formControlName: 'friday',
    fullCalendarDayIndex: 5,
  },
  {
    labelKey: 'activity_planning.date_selection.week.saturday',
    formControlName: 'saturday',
    fullCalendarDayIndex: 6,
  },
  {
    labelKey: 'activity_planning.date_selection.week.sunday',
    formControlName: 'sunday',
    fullCalendarDayIndex: 0,
  },
];
